<template lang="pug">
transition(name="el-fade-in-linear")
  #dwgLayer.comAll(v-dragDiv,v-show="!actionData.isMini")
    .title.moveDragDiv
      span {{actionData.cnName}}
      i.el-icon-minus.minibtn(title='最小化' @click='miniCom')
      i.el-icon-close.closebtn(title='关闭' @click='closeLayer')
    .contentLayer
      .contentLayer_top
        el-button(size='mini' type='primary' @click='allselect') 全 选
        el-button(size='mini' type='primary' plain='' @click='selected') 反 选
      el-table.contentLayer_table(ref='multipleTable',
        :data='tableData',size='mini',tooltip-effect='dark',style='width: 100%',
        border
        @select='layerChange',
        @select-all='allChange',
        @selection-change='handleSelectionChange')
        el-table-column(type='selection' width='55')
        el-table-column(prop='name' label='图层名称' show-overflow-tooltip)
        el-table-column(prop='name' label='可见性' align='center' width='90')
          template(slot-scope='scope')
            img(src='../images/eyeON.png' alt='图标' v-if='scope.row.isVisible')
            img(src='../images/eyeOFF.png' alt='图标' v-if='!scope.row.isVisible')
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      multipleSelection: [],
      tableData: []
    };
  },
  mounted() {
    this.multipleSelection = [];
    this.getTableData();
  },
  methods: {
    miniCom() {
      this.$emit('closeCom', 'layer', true);
    },
    closeLayer() {
      this.$emit('closeCom', 'layer', false);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    layerChange(selection, row) {
      mongeApiMlib.setVisibleById(row.id, !row.isVisible);
      this.getTableData();
    },
    allChange(selection) {
      if (selection.length == 0) {
        mongeApiMlib.setAllVisible(false);
      } else {
        mongeApiMlib.setAllVisible(true);
      }
    },
    async getTableData() {
      this.tableData = await mongeApiMlib.mapLayers();
      this.tableData.forEach(element => {
        if (element.isVisible) {
          this.$nextTick(() => {
            this.$refs.multipleTable.toggleRowSelection(element, true);
          });
        }
      });
    },
    // 全选
    allselect() {
      this.$refs.multipleTable.toggleAllSelection();
    },
    // 反选
    selected() {
      this.tableData.forEach(row => {
        this.$refs.multipleTable.toggleRowSelection(row);
        mongeApiMlib.setVisibleById(row.id, !row.isVisible);
      });
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>

<style lang="stylus" scoped>
#dwgLayer
  position absolute
  bottom 15vh
  left calc(50% - 290px)
  width 580px
  height 450px
  margin: 0 auto
  z-index 4
  .contentLayer
    width 100%
    height 460px
    padding 10px 20px
    display flex
    flex-direction column
    .contentLayer_top
      margin-bottom 10px
    .contentLayer_table
      width 100%
      height: calc(100% - 40px)
      overflow-y auto

</style>
